// import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { AWS_CONFIG, AWS_KMSCLIENT_CONFIG } from '../../../constants/constants';

const { KMSClient, EncryptCommand, DecryptCommand } = require('@aws-sdk/client-kms');

// get identity pool creds (in my case)
// const credentials = fromCognitoIdentityPool({
//   identityPoolId: AWS_CONFIG.COGNITO_IDENTITY_POOL_ID,
//   clientConfig: { region: AWS_CONFIG.REGION },
// });

// return a Response object containing Binary array
export const encryptKMS = async (text) => {
  // debug-console.log('encryptKMS: 1. input text=' + text.length);
  // a client can be shared by different commands.
  // const client = new KMSClient({ region: AWS_CONFIG.KMS_REGION, credentials });
  const client = new KMSClient(AWS_KMSCLIENT_CONFIG);
  const byteArr = textEncodeToByteArray(text);
  // debug-console.log('encryptKMS: -> 2. byteArr length=' + byteArr.length);
  // // debug-console.log(byteArr);
  const input = {
    KeyId: AWS_CONFIG.KMS_KEY_ID,
    Plaintext: byteArr, // Uint8Array() : e.g. Buffer.from("") or new TextEncoder().encode("")   // required
  };

  const command = new EncryptCommand(input);
  const response = await client.send(command);
  // debug-console.log('encryptKMS: 3. encryptedObject response=');
  // debug-console.log(response);

  // const decrypted = await decryptKMS(response);
  // // debug-console.log('encryptKMS: 4. Test decrypted Obj=');
  // // debug-console.log(decrypted);

  return response;
  //   response ==
  //  {
  //     "CiphertextBlob": "<binary data>",
  //     "EncryptionAlgorithm": "RSAES_OAEP_SHA_256",
  //     "KeyId": "arn:aws:kms:us-west-2:111122223333:key/0987dcba-09fe-87dc-65ba-ab0987654321"
  //  }
};

// TextEncoder().encode: Returns the result of running UTF-8's encoder.
export const textEncodeToByteArray = (text) => {
  // debug-console.log('   |--> textEncodeToByteArray: text=' + text.length);
  // // debug-console.log(text);
  const result = new TextEncoder().encode(text);
  // // debug-console.log(
  //   '   |--> textEncodeToByteArray: (TextEncoder.encode using UTF-8 encoder -> ByteArray): ',
  // );
  // // debug-console.log(result);
  return result;
};

// use TextDecoder to decode Base64-encoded arr to Base64 Text
export const uint8ArrayDecodeToBase64Text = (uint8array) => {
  const result = new TextDecoder().decode(uint8array);
  // debug-console.log('   |--> uint8ArrayDecodeToBase64Text: arr=');
  // // debug-console.log(uint8array);
  // debug-console.log('   |--> uint8ArrayDecodeToBase64Text: (TextDecoder.decode -> Base64 Text): ' + result.length,  );
  // // debug-console.log(result);
  return result;
};

// used to convert from Base64 in DB to Latin1 (tree data)
export const base64rawDecryptToUserData = async (base64ByteArr) => {
  // debug-console.log('base64rawDecryptToUserData: 1. base64ByteArr length=' + base64ByteArr.length);
  // // debug-console.log(base64ByteArr);

  const base64Text2 = uint8ArrayDecodeToBase64Text(base64ByteArr);
  // debug-console.log('base64rawDecryptToUserData: -> 2. base64Text2:' + base64Text2.length);
  // // debug-console.log(base64Text2);

  // String.fromCharCode(base64ByteArr); // ?? _uint8arrayToBase64Text(arr);
  const utf8Text = atob(base64Text2);
  // // debug-console.log('------------------' + atob_utf8(textBase64));
  // debug-console.log('base64rawDecryptToUserData: 3. atob to utf8Text:' + utf8Text.length);
  // // debug-console.log(utf8Text);

  const encryptedByteArr = textToCharCodeArray(utf8Text);
  // debug-console.log('base64rawDecryptToUserData: 4. direct charCodeAt() to encryptedByteArr=');
  // debug-console.log(encryptedByteArr);

  const userData = await decryptKMS(new Uint8Array(encryptedByteArr));
  // debug-console.log('base64rawDecryptToUserData: <-- 5.userData:' + userData.length);
  return userData;
};

const textToCharCodeArray = (text) => {
  // debug-console.log('   |--> textToCharCodeArray: 1.text:' + text.length);
  const byteArr = [];
  for (let i = 0; i < text.length; i += 1) {
    byteArr.push(text.charCodeAt(i));
  }
  // debug-console.log('   |--> textToCharCodeArray: byteArr:' + byteArr.length);
  return byteArr;
};

// simple decryption using double decode instead of KMS key
export const simpleDecode = (base64ByteArr) => {
  // debug-console.log('simpleDecode: 1. base64ByteArr length=' + base64ByteArr.length);
  // // debug-console.log(base64ByteArr);

  const base64Text2 = uint8ArrayDecodeToBase64Text(base64ByteArr);
  // debug-console.log('simpleDecode: -> 2. base64Text2:' + base64Text2.length);
  // // debug-console.log(base64Text2);

  // String.fromCharCode(base64ByteArr); // ?? _uint8arrayToBase64Text(arr);
  const utf8Text = atob(base64Text2);
  // // debug-console.log('------------------' + atob_utf8(textBase64));
  // debug-console.log('simpleDecode: 3. atob to userData/utf8Text:' + utf8Text.length);
  // // debug-console.log(utf8Text);

  const byteArr = textToCharCodeArray(utf8Text);
  // debug-console.log('simpleDecode: 4. byteArr length:' + byteArr.length);

  return byteArr;
};

// simple encryption using double encode instead of KMS key
export const simpleEncode = (text) => {
  // debug-console.log('simpleEncode: 1. input text=' + text.length);

  const byteArr = textEncodeToByteArray(text);
  return byteArrToBase64Text(byteArr);
};

// aka btoa_utf8
export const byteArrToBase64Text = (uin8arr) => {
  // const uin8arr = new Uint8Array(byteArr);
  // debug-console.log('byteArrToBase64Text: 1.uin8arr:');
  // // debug-console.log(uin8arr);

  const latin1Text = String.fromCharCode(...uin8arr);
  // debug-console.log('byteArrToBase64Text: 2. String.fromCharCode() -> latin1Text:' + latin1Text.length);
  // // debug-console.log(latin1Text);

  const base64Text = btoa(latin1Text);
  // debug-console.log('byteArrToBase64Text: <-- 3.btoa: base64text=' + base64Text.length);
  // // debug-console.log(base64Text);
  return base64Text;
};

// atob: Base64->UTF8: Decodes a string of Base64-encoded data into bytes,
// and encodes those bytes into a string using Latin-1 (ISO-8859-1).
// function atob_utf8(base64Text) {
//   const value_latin1 = atob(base64Text);
//   const result = new TextDecoder('utf-8').decode(
//     Uint8Array.from({ length: value_latin1.length }, (element, index) =>
//       value_latin1.charCodeAt(index),
//     ),
//   );
//   // debug-console.log('atob_utf8:base64Text=' + base64Text);
//   // debug-console.log('atob_utf8:--> value_latin1=' + value_latin1);
//   // debug-console.log('atob_utf8:--> String result:' + result);
//   return result;
// }

// return a Response object, containing raw byte array inside
// param can be: encrypted bytearr or AWS enrypted object
export const decryptKMS = async (encrypted) => {
  if (encrypted.CiphertextBlob) {
    // an encrypted object
    encrypted = encrypted.CiphertextBlob;
  }
  // a client can be shared by different commands.
  const client = new KMSClient({ region: AWS_CONFIG.KMS_REGION, credentials });
  const input = {
    KeyId: AWS_CONFIG.KMS_KEY_ID,
    CiphertextBlob: encrypted,
  };
  // debug-console.log('decryptKMS: 1. request=');
  // debug-console.log(input);
  const command = new DecryptCommand(input);
  try {
    const decrypteResponse = await client.send(command);
    // eslint-disable-next-line
    // debug-console.log('decryptKMS: 2. decryptedObj=');
    // debug-console.log(decrypteResponse);

    const decryptedText = JSON.stringify(uint8ArrayDecodeToBase64Text(decrypteResponse.Plaintext));
    // debug-console.log('decryptKMS: <-- 3. decryptedText.length=' + decryptedText.length);
    return decryptedText;
  } catch (err) {
    alert('Error in KMS');
    return '';
  }

  // { // DecryptResponse
  //   KeyId: "STRING_VALUE",
  //   Plaintext: new Uint8Array(),
  //   EncryptionAlgorithm: "SYMMETRIC_DEFAULT" || "RSAES_OAEP_SHA_1" || "RSAES_OAEP_SHA_256" || "SM2PKE",
  //   CiphertextForRecipient: new Uint8Array(),
  // };
};

// deprecated: too complex
// to convert encrypted data to Base64 before saving to DB
// const uin8arrayTransformToBase64 = (byteArray1) => {
//   // debug-console.log('uin8arrayTransformToBase64: 1.arr=');
//   const base64Text1 = uint8ArrayDecodeToBase64Text(byteArray1);
//   // base64: 6bit -> 1 char in the text
//   // debug-console.log('uin8arrayTransformToBase64: 2.base64Text1= ' + base64Text1.length);
//   // // debug-console.log(base64Text1);

//   // IMPORTANT: Encode a Base64 String using UTF-8 encoder to get Byte array
//   // It means the byte array represent base64Text1 String
//   // Since Base64 char uses 6bit, now is represented by 8 bit, means array size increase 30%...
//   const byteArray2 = new TextEncoder('utf-8').encode(base64Text1);
//   // debug-console.log('uin8arrayTransformToBase64: 3.TextEncoder(utf-8).encode -> byteArray2=');
//   // debug-console.log(byteArray2);

//   const utf8Text = String.fromCharCode(...byteArray2);
//   // debug-console.log(
//     'uin8arrayTransformToBase64: 4. String.fromCharCode() direct to utf8Text:' + utf8Text.length,
//   );
//   // debug-console.log(utf8Text);

//   const base64Text2 = btoa(utf8Text);
//   // debug-console.log('uin8arrayTransformToBase64: <- 5.btoa to base64Text2:' + base64Text2.length);
//   // debug-console.log(base64Text2);
//   return base64Text2;
// };

export default encryptKMS;
